<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <div class="product-detail" v-if="detail.businessId || detail.businessId === 0" ref="product">
      <div class="imgs-container">
        <van-swipe class="imgs" @change="index => (swipeCurrent = index)" indicator-color="#e7141a">
          <van-swipe-item v-for="(item, index) in detail.imageUrlList">
            <img :src="thumb1200(item)" />
          </van-swipe-item>
        </van-swipe>
        <div class="ind">{{ swipeCurrent + 1 }}/{{ detail.imageUrlList.length }}</div>
        <div class="div">{{ viewNum }}人感兴趣</div>
      </div>
      <div class="info">
        <div class="price-sale">
          <div class="price">
            <span style="font-size: 15px">￥</span>
            <span>{{ detail.salePrice }}</span>
            <span class="old-price">￥{{ detail.originalPrice }}</span>
            <div v-if="detail.immediateRemissionPriceSwitch" class="immediateRemissionPrice">
              到手价￥{{ detail.immediateRemissionPrice }}
            </div>
            <span v-else>
              <span class="discount" v-if="discount && discount < 10"
                >{{ discount < 0.01 ? 0.01 : discount }}折</span
              >
            </span>
          </div>
          <div class="sale">
            <span>已售</span>
            {{ detail.saleCount }}
            <span class="line">|</span>
            <span>库存</span>
            {{ detail.residueCount }}
          </div>
        </div>
        <div class="productTags" v-if="detail.refundType == 1">
          <div class="tagName">特价不可退</div>
        </div>
        <div class="notice" v-if="detail.writeOffTimeStart">
          <a href="#notice"></a>
          <div class="value">
            使用时间：{{ detail.writeOffTimeStart }}~{{ detail.writeOffTimeEnd }}
          </div>
          购买须知
          <van-icon name="arrow" style="margin-left: 10rpx" />
        </div>
        <div class="title">
          <img
            style="width: 40px"
            :src="iconUrl + 'productTag.png'"
            v-if="detail.refundType !== 1"
          />
          {{ detail.productName }}
        </div>
        <!-- <div class="sec-title" v-if="detail.title">{{ detail.productName }}</div> -->
        <div class="subtitle">{{ detail.productDescription }}</div>
        <div class="tags">
          <template v-for="(tag, index) in detail.serviceContentList">
            <div
              class="tag"
              :style="`justify-content:${
                index === 0 ? 'flex-start' : index === 1 ? 'center' : 'flex-end'
              }`"
            >
              <van-icon name="info-o" size="13" class="icon" />
              {{ tag }}
            </div>
          </template>
        </div>
        <div
          class="distribution"
          v-if="distribution.distributionAmountDisplayFlag && distribution.maxDistributionAmount"
        >
          <img
            class="img"
            @click="jumpShareCopy(distribution)"
            :src="`${iconUrl}distribution.png`"
          />
          <div class="money">
            ￥{{ distribution.minDistributionAmount }}
            <span v-if="distribution.minDistributionAmount !== distribution.maxDistributionAmount"
              >~￥{{ distribution.maxDistributionAmount }}</span
            >
          </div>
        </div>
      </div>
      <!-- 礼包商品 -->
      <div class="giftBagBlock" v-if="detail.packSku">
        <div class="header">
          <span class="title">每份套餐内容</span>
          <span class="toAll" @click="handleShowPopup('package')">
            全部
            <van-icon name="arrow" />
          </span>
        </div>
        <div class="list">
          <div class="listContainer">
            <div class="giftItem" v-for="(item, i) in giftBagList" :key="'item' + i">
              <div class="viewImg">
                <img class="mainImg" :src="item.skuImageUrl" alt />
                <span>×{{ item.num }}</span>
                <span>总价值:￥{{ (item.originalPrice * item.num).toFixed(2) }}</span>
              </div>
              <div class="title">{{ item.skuName }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 礼包商品 的详情 -->
      <van-action-sheet
        v-model:show="giftShow"
        style="background: #f5f5f5"
        :title="`${
          modelType == 'package'
            ? `套餐详情（${giftBagList?.length}）`
            : `可用卡券（${cuoponList?.length}）`
        }`"
        @click="stopPro($event)"
        @click-overlay="overlay"
      >
        <GiftBagList :type="modelType" :cuoponList="cuoponList" />
      </van-action-sheet>
      <com-store
        :logo="detail.businessLogo"
        :name="detail.businessTitle"
        :bid="detail.businessId + ''"
        :pid="id"
        :areaIds="detail.areaIds"
      />
      <div class="block timeDetail" v-if="detail.displayTimeDiv">
        <div class="title header">
          使用时间详情
          <span class="text" @click="handleShowPopup('coupon')" v-if="detail.packSku">
            <span class="time">查看卡券可用时间</span>
            <van-icon name="warning-o" size="16" />
          </span>
        </div>
        <div class="time-item">
          <div class="label">售卖时间</div>
          <div class="value">{{ detail.shelfTimeAppDisplayContent }}</div>
        </div>

        <div class="time-item">
          <div class="label">核销时间</div>
          <div class="value">{{ detail.writeOffTimeAppDisplayContent }}</div>
        </div>
        <div class="time-item" v-if="detail.timeSlotType > 0">
          <div class="label">可用时段</div>
          <div cass="value" v-if="detail.timeSlotType == 2">
            <template v-if="detail.specifiedTimeList && detail.specifiedTimeList.length > 0">
              <div v-for="(item, index) in detail.specifiedTimeList" :key="'specialTime' + index">
                <span class="value" v-if="item.specifiedTimeType == 2">{{ item.week }}</span>
                <span class="value" v-if="item.specifiedTimeType == 3">{{ item.date }}</span>
                <span v-if="item.specifiedTimeType != 1">(</span>
                <span>{{ item.time }}</span>
                <span v-if="item.specifiedTimeType != 1">)</span>
              </div>
            </template>
            <div v-else>{{ detail.specifiedTimeMark }}</div>
          </div>
          <template v-else>
            <div class="value" v-if="detail.timeSlotType == 1">门店营业时间内可用</div>
            <div class="value" v-else>{{ detail.canuse }}</div>
          </template>
        </div>
        <div
          class="time-item"
          v-if="
            detail.unavailableDateType > 1 &&
            (detail.weekUse ||
              (detail.specialUse && detail.specialUse.length) ||
              (detail.timeUse && detail.timeUse.length))
          "
        >
          <div class="label">不可用日期</div>
          <div class="value" style="color: #e7141a">
            <div>{{ detail.weekUse }}</div>
            <div v-for="item in detail.specialUse" :key="item">{{ item }}</div>
            <div v-for="item in detail.timeUse" :key="item">{{ item }}</div>
          </div>
        </div>
      </div>

      <comSetMeal
        :data="detail.skuDetailList"
        v-if="detail.skuDetailList && detail.skuDetailList.length"
      />

      <div class="block">
        <div class="title">购买须知</div>
        <div id="notice" v-html="detail.purchaseInstructions"></div>
      </div>
      <div class="block">
        <div class="title">商品详情</div>
        <div v-html="detail.productDetailContent"></div>
      </div>
      <div class="block" :style="`margin-bottom:${recommend.length ? 0 : 70}px;padding:0`">
        <comComment :pid="id" />
      </div>
      <div class="recommend-box" v-if="recommend.length">
        <div class="recommend">
          <div class="title">
            <img class="icon" :src="`${iconUrl}biaoti_icon_left@2x.png`" />
            <div class="text">商品推荐</div>
            <img class="icon" :src="`${iconUrl}biaoti_icon_right@2x.png`" />
          </div>
          <div class="products">
            <bm-product v-for="item in recommend" :key="item.id" :data="item" />
          </div>
        </div>
      </div>
      <van-action-sheet v-model:show="soldShow" :closabled="false">
        <div class="sold-out">
          <div class="title">来晚了，看看其他精选</div>
          <div class="desc">
            <bm-product v-for="item in recommend" :data="item" :key="item.id" :source="10" />
          </div>
        </div>
      </van-action-sheet>
      <comAction :detail="detail" v-if="detail.businessId" />
      <bm-toTop />
    </div>
  </van-pull-refresh>
</template>

<script setup>
import { thumb1200 } from '@/util/filter'
import { watch } from 'vue'
import { useRouter } from 'vue-router'
import useClipboard from 'vue-clipboard3'
import fetch from '@/plugin/axios'
import { formatFullDate } from '@/util/filter'

const { toClipboard } = useClipboard()
let router = useRouter()

watch(
  () => router.currentRoute.value,
  (route, preRoute) => {
    if (route.name === 'product-id-detail') {
      if (route.params.id && route.params.id != preRoute.params.id) {
        location.reload()
      }
    }
  }
)
</script>

<script>
import comAction from './__com__/action.vue'
import comStore from './__com__/store.vue'
import comComment from './__com__/comment'
import GiftBagList from './__com__/giftBagList'
import comSetMeal from './__com__/setMeal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { Notify } from 'vant'
import userTrack from '@/util/userTrack'
import { useRouter } from 'vue-router'

let inTime = 0
let source = 1

export default {
  components: { comAction, comStore, comComment, GiftBagList, comSetMeal },
  data() {
    return {
      iconUrl: process.env.VUE_APP_baseStaticUrl + 'icon/common/',
      id: '', //商品id
      swipeCurrent: 0,
      soldShow: false,
      share: false,
      viewNum: 0,
      refreshing: false,
      giftBagDetailShow: false,
      router: useRouter(),
      modelType: 'package',
      cuoponListLen: 0,
      cuoponList: [],
      giftShow: false
    }
  },
  computed: {
    ...mapGetters({
      detail: 'mall/product/productDetail',
      distribution: 'mall/product/productDistributionInfo',
      recommend: 'mall/product/recommend',
      userInfo: 'common/account/userInfo',
      isLogin: 'common/account/isLogin',
      isWx: 'common/sys/isWx'
    }),
    giftBagList() {
      console.log(this.detail.skuPackageList[0]?.skuList, 'computed')
      return this.detail.skuPackageList[0]?.skuList
    },
    discount() {
      return ((this.detail.salePrice / this.detail.originalPrice) * 10).toFixed(1)
    },
    wxConfig() {
      return true
    },
  },
  watch: {
    'router.currentRoute.value.path'(route) {
      if (route.name === 'product') {
        if (route.params.id && route.params.id !== this.id) {
          location.reload()
        }
      }
    },
    detail(v) {
      this.soldShow = v.productState === 4 && !this.$route?.query?.isDebug
    },
    modelType(v) {
      console.log(v, 'watch v')
      if (v == 'coupon') {
        let idList = []
        console.log(this.giftBagList)
        this.giftBagList.forEach(item => {
          if (item.skuType == 1) {
            idList.push(item.couponId)
          }
        })
        this.getCuoponList(idList)
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    source = to.query.source || 1
    inTime = new Date().getTime()
    console.log('?????????????????')
    next()
  },
  beforeRouteLeave(to, from, next) {
    console.log(this.userInfo)
    userTrack.submitTrack({
      event_type: 'page_view',
      event_page: 'product_detail',
      event_from: parseInt(source),
      event_value: {
        product_id: this.id,
        duration: (new Date().getTime() - inTime) / 1000,
        wechat_ad: this.detail?.wechatAd,
        wx_open_id: this.userInfo?.wxOpenId || ''
      }
    })
    next()
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      getProductDetail: 'mall/product/getProductDetail'
    }),
    stopPro(e) {
      e.stopPropraation() //组织冒泡
      e.preventDefaut() //组织默认事件
    },
    overlay() {
      this.giftShow = true
      setTimeout(() => {
        this.giftShow = false
      }, 100)
    },
    handleShowPopup(type) {
      this.giftShow = true
      this.modelType = type
    },
    getCuoponList(idList) {
      fetch
        .post(`/boom-center-marketing-service/app/coupon/product/sku/list`, {
          idList
        })
        .then(res => {
          if (res.length) {
            this.giftBagList.forEach(item => {
              res?.map(ele => {
                if (item.couponId == ele.id) {
                  ele.skuImageUrl = item.skuImageUrl
                  ele.num = item.num
                }
              })
            })
            this.cuoponList = res.map(item => {
              item.useStartTime = formatFullDate(item.useStartTime)
              item.useEndTime = formatFullDate(item.useEndTime)
              return item
            })
            console.log(this.cuoponList, 'this.cuoponList')
          }
        })
    },
    specialTimeFormat(specialTime) {
      let weekList = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日']
      let startWeekDay = weekList[specialTime.startWeek - 1] || ''
      let endWeekDay = weekList[specialTime.endWeek - 1] || ''
      let x = startWeekDay && endWeekDay ? '至' : ''
      return startWeekDay + x + endWeekDay
    },
    jumpShareCopy(dis) {
      this.router.push(
        `/shop/shareCopy?id=${this.$route.params.id}&min=${dis.minDistributionAmount}&max=${dis.maxDistributionAmount}`
      )
    },
    getProductView() {
      this.$api.statistics.getPv({ code: 1, id: this.id }).then(res => {
        this.viewNum = res
      })
    },
    async copy() {
      await this.toClipboard(
        `https://${location.host + location.pathname}?shareId=${
          this.userInfo.id
        }&time=${new Date().getTime()}`
      )
      Notify({ type: 'success', message: '复制链接成功' })
    },
    onRefresh() {
      this.getProductDetail(this.id).finally(() => {
        this.refreshing = false
      })
      this.getProductView()
    },
    getWxConfig() {
      let appid = 'wx5d2e232ce5454554'
      if (window.location.href.includes('h5.mall.tanchi.shop')) {
        appid = 'wx4c71feaac422f7d9'
      }
      this.$http
        .post('/boom-center-product-service/wechat/createJsapiSignature', {
          appId: appid,
          url: location.href
        })
        .then(res => {
          console.log(res, '=========> 商品详情微信配置')
          wx.config({
            debug: false,
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ['chooseWXPay', 'updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
          })
        })
      wx.error(err => {
        console.log('初始化错误,', err)
      })
    },
    handleForawrd() {
      wx.ready(() => {
        console.log(this.$route.name, '=====>> this.$route.name')
        if (this.$route.name !== 'product-id-detail') return
        let shareData = {
          title: this.detail?.productName,
          desc: this.detail?.productDescription,
          link: `https://${location.host + location.pathname}?id=${this.detail.id}&shareId=${
            this.userInfo.id
          }&time=${new Date().getTime()}`, //你的跳转链接
          imgUrl: this.detail?.imageUrlList?.length ? this.detail.imageUrlList[0] : '', //LOGO链接
          success: function (res) {
            //alert('谢谢您的支持！');
          },
          cancel: function (res) {
            alert('已取消分享')
          }
        }
        console.log('--> productDetail =>', this.detail)
        console.log(shareData, '=====>> shareData')
        wx.updateAppMessageShareData(shareData)
        // wx.updateTimelineShareData(shareData)
      })
    }
  },
  created() {
    let shareId = this.$route.query.shareId
    this.$router = this.router.currentRoute.value

    if (shareId && !isNaN(shareId)) {
      // 若shareId存在
      if (shareId !== this.userInfo.id) {
        //并且不是本人的id
        console.log('缓存shareId=', this.$route.query.shareId)
        this.$store.commit('common/account/update', {
          key: 'inviteId',
          value: this.$route.query.shareId
        })
        if (this.isLogin) {
          this.$store.dispatch('common/account/weakBind')
          this.router.replace(`${this.$route.path}?shareId=${this.userInfo.id}`) //替换为本人的id--复制链接功能
        }
      }
    } else {
      //若shareid不存在
      if (this.isLogin) {
        if (this.$route.query.from) {
          this.router.replace(
            `${this.$route.path}?shareId=${this.userInfo.id}&from=${this.$route.query.from}`
          )
        } else {
          this.router.replace(`${this.$route.path}?shareId=${this.userInfo.id}`)
        }
      }
    }
  },
  mounted() {
    sessionStorage['productPath'] = this.$route.fullPath
    if (!this.$route.params.id) {
      this.$notify('参数错误')
    } else {
      this.id = this.$route.params.id
      if (this.isWx && this.wxConfig) {
        this.getWxConfig() //jssdk初始化
      }
      this.getProductDetail(this.$route.params.id).then(res => {
        console.log(res, '=====>> res', this.detail)
        this.handleForawrd()
      })
      this.getProductView()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/img {
  max-width: 100% !important;
}

.product-detail {
  height: 100%;
  overflow: auto;
  padding-bottom: 60px;

  .imgs-container {
    width: 100%;
    height: 300px;
    position: relative;
    transition: all 0.5s;

    .imgs {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .ind,
    .div {
      position: absolute;
      z-index: 9;
      bottom: 15px;
      right: 0;
      background-color: rgba(0, 0, 0, 0.4);
      padding: 6px 15px;
      padding-right: 10px;
      border-radius: 30px 0 0 30px;
      color: #fff;
      font-weight: bold;
      font-size: 12px;
      backdrop-filter: blur(5px);
    }

    .div {
      bottom: 55px;
    }
  }

  .info {
    padding: 15px;
    border-bottom: 15px solid #f5f5f5;
    background-color: #fff;

    .price-sale {
      display: flex;
      align-items: center;

      .price {
        flex: 1;
        overflow: hidden;
        color: #e7141a;
        font-size: 25px;
        font-weight: bold;
        text-overflow: ellipsis;

        .old-price {
          font-size: 14px;
          color: #999;
          font-weight: normal;
          text-decoration: line-through;
          margin-left: 5px;
        }

        .discount {
          position: relative;
          border: 1px solid red;
          font-size: 11px;
          color: red;
          height: fit-content;
          border-radius: 30px;
          padding: 2px 7px;
          margin-left: 15px;
        }
        .immediateRemissionPrice {
          position: relative;
          transform: translateY(-3px);
          font-size: 12px;
          background: #e7141a10;
          color: #e7141a;
          border: 1px solid #e7141a;
          border-radius: 5px;
          padding: 2px 5px;
          width: fit-content;
          display: inline-block;
          margin-left: 5px;
        }
      }

      .sale {
        background-color: #f5f5f5;
        border-radius: 30px;
        height: fit-content;
        padding: 5px 15px;
        font-weight: bold;
        color: #333;
        font-size: 12px;

        span {
          font-weight: normal;
          color: #999;
        }

        .line {
          margin: 0 5px;
        }
      }
    }

    .notice {
      padding: 10px;
      background-color: #333333;
      display: flex;
      align-items: center;
      font-size: 11px;
      color: #ffffff;
      border-radius: 5px;
      margin: 15px 0;
      position: relative;

      a {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      &:active {
        filter: brightness(115%);
      }

      .value {
        flex: 1;
      }
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      margin: 10px 0;
      margin-bottom: 5px;
      color: #333;
    }

    .sec-title {
      font-size: 14px;
      color: #666;
      margin-top: 2px;
    }

    .subtitle {
      font-size: 12px;
      color: #999;
    }

    .tags {
      font-size: 11px;
      font-weight: 500;
      color: #454545;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      margin-top: 15px;
      border-bottom: 1px solid #f9f9f9;

      .tag {
        flex: 1;
        display: flex;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;

        .icon {
          margin-right: 10rpx;
        }
      }
    }

    .distribution {
      width: 100%;
      height: 80px;
      margin-top: 30rpx;
      position: relative;
      padding: 30rpx;

      .img {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .money {
        position: absolute;
        z-index: 2;
        color: rgba(255, 255, 247, 0.8);
        font-weight: bold;
        font-size: 15px;
        left: 15px;
        bottom: 18px;
      }

      &:active {
        filter: brightness(95%);
      }
    }
  }

  .giftBagBlock {
    height: 182px;
    padding: 10px 14px;
    background-color: #fff;
    margin-bottom: 15px;
    font-size: 16px;
    color: #333333;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 9px;

      .title {
        height: 21px;
        font-size: 15px;
        font-weight: bold;
        line-height: 21px;
      }

      .toAll {
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        display: flex;
        align-items: center;
      }
    }

    .list {
      max-width: 100%;

      .listContainer {
        overflow: auto;
        white-space: nowrap;

        .giftItem {
          width: 88px;
          display: inline-block;
          margin-right: 10px;

          .viewImg {
            position: relative;

            img {
              height: 88px;
              width: 88px;
              border-radius: 6px;
            }

            span {
              position: absolute;
              display: inline-block;
              min-height: 17px;
              font-weight: 500;
              color: #ffffff;
              line-height: 14px;

              &:nth-of-type(1) {
                right: 0;
                top: 0;
                font-size: 10px;
                background-color: rgba(0, 0, 0, 0.3);
                border-radius: 0 6px 0 6px;
                padding: 2px 5px;
              }

              &:nth-of-type(2) {
                left: 0;
                bottom: 0;
                font-size: 12px;
                width: 100%;
                padding: 2px 5px;
                background: linear-gradient(
                  180deg,
                  rgba(0, 0, 0, 0) 0%,
                  rgba(0, 0, 0, 0.6) 29%,
                  #000000 100%
                );
              }
            }
          }

          .title {
            padding: 2px;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            line-height: 16px;
            width: 100%;
            white-space: normal;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }

  .block {
    font-size: 15px;
    padding: 15px;
    border-bottom: 15px solid #f5f5f5;
    background-color: #fff;
    overflow: hidden;

    .title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin-bottom: 15px;
    }
  }

  .recommend-box {
    position: relative;
    z-index: 9;

    .recommend {
      padding: 8px;
      box-sizing: border-box;
      border-radius: 10px 10px 0px 0px;
      background: @background;

      .title {
        text-align: center;
        margin: 0 auto;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        font-size: 15px;

        .icon {
          width: 50px;
        }

        .text {
          white-space: nowrap;
          margin: 0 10px;
        }
      }

      .products {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }
  }

  .sold-out {
    padding: 15px;

    .weui-mask {
      z-index: 997;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #343434;
      text-align: center;
      padding-bottom: 15px;
    }

    .desc {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      height: 60vh;
      padding-bottom: 50px;
      overflow: auto;
    }
  }
}

.productTags {
  padding: 10px 0 0 0;
  display: flex;

  .tagName {
    margin-right: 10px;
    font-size: 12px;
    width: 68px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    opacity: 0.8;
    border: 1px solid #ff3023;
    color: #e7141a;
    font-weight: 600;
  }
}

.timeDetail {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      display: flex;
      align-items: center;

      .time {
        color: #333;
        font-size: 14px;
        font-weight: normal;
        margin-right: 3px;
      }
    }
  }

  .time-item {
    justify-content: flex-start;
    font-size: 14px;
    // font-weight: 550;
    color: #9a9a9a;
    // margin-top: 30rpx;
    padding: 0;
    display: flex;

    .label {
      flex-grow: 0;
      flex-shrink: 0;
      font-weight: 550;
      width: 70px;
      margin-right: 25px;
      color: #343434;
    }

    .value {
      overflow: hidden;
      margin-right: 8px;
    }
  }
}
</style>
